import Icon from 'components/common/Icon';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useEffect, useState } from 'react';
import Profile from './components/Profile';

interface MyData {
  coin: number;
  following: number;
  follower: number;
}

const MyProfile = () => {
  const { open } = useBottomSheet();
  const [myData, setMyData] = useState<MyData>({ coin: 0, following: 0, follower: 0 });

  const goToFriendsList = (type: 'following' | 'follower') => {
    const isFollowing = type === 'following';

    Transition.showPage(Def.PAGE_FRIENDSLIST, {
      isFollowing: isFollowing,
      uid: myinfo.fbUid,
      nick: myinfo.nick,
    });
  };

  const goToSetting = () => {
    Transition.showPage(Def.PAGE_SETTINGS);
  };

  useEffect(() => {
    setMyData({
      coin: MyDataManager.getCoin(),
      following: FriendsDataManager.getFollowingList().length,
      follower: FriendsDataManager.getFollowerList().length,
    });
  }, []);

  return (
    <>
      <Profile userInfo={myinfo}>
        <Profile.Image />

        <div className="flex flex-col">
          <div className="mt-4 flex items-center gap-2">
            <Profile.Name />
            <Profile.Coin coin={myData.coin} type="my" />
          </div>
          <div className="mb-4 mt-3 flex flex-col items-start gap-3">
            <Profile.Uid />
            <div className="flex items-center gap-2">
              <Profile.Country />
              <Profile.TimeInfo />
            </div>
          </div>
          <hr className="m-0 h-[1px] w-full border-base-border-default" />
          <div className="mb-7 mt-4 flex items-center justify-between rounded-full bg-base-bg-subtle px-2 py-1">
            <Icon name="profile/profile.svg" className="flex-shrink-0 items-center justify-center px-2 py-1" size={24} />
            <div onClick={() => goToFriendsList('following')} className="flex flex-1 items-center justify-center gap-2 py-3">
              <Profile.Stats type="following" count={myData.following} />
            </div>
            <div onClick={() => goToFriendsList('follower')} className="flex flex-1 items-center justify-center gap-2 py-3">
              <Profile.Stats type="follower" count={myData.follower} />
            </div>
          </div>
          <div className="sticky bottom-0 flex items-center justify-center gap-2">
            <div onClick={() => open('ProfileEdit', { options: { zIndex: 99 } })} className="flex flex-1 items-center justify-center gap-1 rounded-full bg-btn-bg-primary px-5 py-4">
              <Icon name="profile/edit.svg" className="flex items-center justify-center p-[2px]" size={24} style={{ filter: 'brightness(0)' }} />
              <div className="typography-headline-lg text-btn-txt-primary">{brsc.edit_profile}</div>
            </div>
            <div onClick={goToSetting} className="flex items-center justify-center rounded-lg bg-btn-bg-normal p-3">
              <img className="h-6 w-6" src={`/imgweb/scene/ic_setting.svg`} alt="" />
            </div>
          </div>
        </div>
      </Profile>
    </>
  );
};
export default MyProfile;
